import LlmList from "./llm/LlmList";
import FineTuningList from "./llm-rag/BrainsList";
import BrainPage from "./llm-rag/BrainPage";
import ChatPage from "./llm-rag/ChatPage";
import ThreadPage from "./llm-rag/ThreadPage";

const routes = [
    { path: "company/:company/ai/llm/list", component: () => <LlmList />, isSidebar: true, isPublic: false },
    {
        path: "company/:company/ai/llm-rag/list",
        component: () => <FineTuningList />,
        isSidebar: true,
        isPublic: false,
    },
    {
        path: "company/:company/ai/llm-rag/:brainId",
        component: () => <BrainPage />,
        isSidebar: true,
        isPublic: false,
    },
    {
        path: "company/:company/ai/llm-rag/chat/:chatId",
        component: () => <ChatPage />,
        isSidebar: true,
        isPublic: false,
    },
    {
        path: "company/:company/ai/llm-rag/chat/history",
        component: () => <ThreadPage />,
        isSidebar: true,
        isPublic: false,
    },
];

export default routes;
